export default () => 
    <>
        <h4 style={{textAlign:'center', width:'100%'}}>If this app does not work, please contact Per Eskilson, per.eskilson@gmail.com</h4>
    </>
